import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = { class: "card-header card-header-jaya border-primary" }
const _hoisted_3 = { class: "card-body border-top p-5 p-md-9" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, " Pour chaque niveau de chaque facteur, il a été déterminé s’il y avait un lien avec ce service écosystémique ou non, et pourquoi. Un \"Oui\" donne un point, un \"Non\" ne donne pas de point. ", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "fst-italic" }, " Exemple : lien entre le facteur F1-5 (Irrigation : Gestion des prélèvements d’eau pour l’irrigation) et le service écosystémique \"Préservation et santé des sols\": justifications et points associés. ", -1)
const _hoisted_6 = { class: "text-black" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", null, " Les critères de la grille sont cumulatifs, donc les points aussi : par exemple, au niveau 4 du facteur F1-5, on cumule les points des oui-non des niveaux 1 à 4. Le niveau 0 ne rapporte jamais de points. ", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "fst-italic" }, " Dans cet exemple : au niveau 4 du facteur F1-5 : on obtient 0 + 0 + 0 + 1 = 1 point ", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", null, " La note finale est obtenue en additionnant tous les points des facteurs, et en divisant par le plus grand total de points que l’on peut obtenir pour le facteur. On obtient donc la note en % qui apparaît dans les résultats. ", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", { class: "fst-italic" }, [
  /*#__PURE__*/_createTextVNode(" Dans cet exemple : "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Calcul par facteur : F1-1 = 5 points, F2-1 = 4 points, …, F4-2 = 0 point "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("Somme pour tous les facteurs : F1-1 + F2-1 … + F4-2 = 17 points "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("Calcul du total maximum pour le service écosystémique 'Préservation et santé des sols' : Max F1-1 + Max F2-1 + …. + Max F4-2 = 2 + 3 + … + 1 = 55 points "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("Note pour le service écosystémique 'Préservation et santé des sols' : 17/55 = 31% ")
], -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", null, " Chaque service écosystémique a sa propre grille de relations oui-non et ses justifications. Les calculs sont répétés de façon similaire pour obtenir toutes les notes. ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_card_title_jaya = _resolveComponent("card-title-jaya")!
  const _component_Datatable = _resolveComponent("Datatable")!
  const _component_ecosystemic_services_factors_justifications = _resolveComponent("ecosystemic-services-factors-justifications")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_card_title_jaya, {
        "duotune-icon": "technology/teh010",
        title: "Méthode de calcul",
        "sub-title": "Comment est calculée la note pour un service écosystémique ?"
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _hoisted_5,
      _createVNode(_component_Datatable, {
        "enable-items-per-page-dropdown": _ctx.tableData.length > 20,
        "table-data": _ctx.tableData,
        "table-header": _ctx.tableHeader,
        rowsPerPage: 6,
        class: "se-explain-legend my-5"
      }, {
        "cell-factor": _withCtx(({ row: data }) => [
          _createElementVNode("div", _hoisted_6, _toDisplayString(data.factor), 1)
        ]),
        "cell-level": _withCtx(({ row: data }) => [
          _createElementVNode("div", null, _toDisplayString(data.level), 1)
        ]),
        "cell-link": _withCtx(({ row: data }) => [
          _createElementVNode("div", null, _toDisplayString(data.link), 1)
        ]),
        "cell-justification": _withCtx(({ row: data }) => [
          _createElementVNode("div", null, _toDisplayString(data.justification), 1)
        ]),
        "cell-point": _withCtx(({ row: data }) => [
          _createElementVNode("div", null, _toDisplayString(data.point), 1)
        ]),
        _: 1
      }, 8, ["enable-items-per-page-dropdown", "table-data", "table-header"]),
      _hoisted_7,
      _hoisted_8,
      _hoisted_9,
      _hoisted_10,
      _hoisted_11,
      _createVNode(_component_ecosystemic_services_factors_justifications, {
        factors: _ctx.factors,
        "ecosystemic-services": _ctx.ecosystemicServices
      }, null, 8, ["factors", "ecosystemic-services"])
    ])
  ]))
}